import decode from 'jwt-decode';

export function isAuthenticated(guard = 'user') {
  const tokenKey = guard === 'user' ? 'token' : 'equipment_token'; // เลือกโทเค็นตาม Guard
  const token = localStorage.getItem(tokenKey);
  if (!token) return false; // ถ้าไม่มีโทเค็น ให้คืนค่า false

  try {
    const date = new Date().getTime() / 1000; // วันที่ปัจจุบัน (หน่วยวินาที)
    const data = decode(token); // ถอดรหัส JWT
    return date < data.exp; // ตรวจสอบว่าโทเค็นยังไม่หมดอายุ
  } catch (e) {
    return false; // คืนค่า false หากการถอดรหัสล้มเหลว
  }
}

export const AuthMixin = {
  methods: {
    isAuthenticated(guard = 'user') {
      return isAuthenticated(guard);
    },
  },
};

